<script setup lang="ts">
/**
 * Locale-Flagge als kompakter Inline-SVG.
 *
 * <p>DE/EN/RU als 60x42-Streifen (DE) bzw. Union-Jack (EN) bzw. Russland-
 * Trikolore (RU). Standard-Groesse 18x12 Pixel — passend zum 18px-Icon-Set
 * der Topbar (Globe, ChevronDown). Aufrufer kann die SVG ueber `class`
 * oder direkte `width/height` skalieren.
 *
 * <p>Pixelreferenz aus dem Design-Handoff
 * ({@code docs/design-reference/src/components.jsx}, {@code Flag}-Komponente);
 * gleicher Farbcode (DE schwarz/rot/gelb, EN Union-Jack klassisch, RU
 * weiss/blau/rot).
 */

defineProps<{
  locale: 'de' | 'en' | 'ru'
}>()
</script>

<template>
  <svg
    class="locale-flag"
    viewBox="0 0 60 42"
    role="img"
    :aria-label="locale.toUpperCase()"
    preserveAspectRatio="xMidYMid meet"
  >
    <template v-if="locale === 'de'">
      <rect width="60" height="14" fill="#000" />
      <rect y="14" width="60" height="14" fill="#DD0000" />
      <rect y="28" width="60" height="14" fill="#FFCE00" />
    </template>
    <template v-else-if="locale === 'ru'">
      <rect width="60" height="14" fill="#fff" />
      <rect y="14" width="60" height="14" fill="#0039A6" />
      <rect y="28" width="60" height="14" fill="#D52B1E" />
    </template>
    <template v-else>
      <clipPath :id="`locale-flag-clip-${locale}`">
        <rect width="60" height="42" />
      </clipPath>
      <g :clip-path="`url(#locale-flag-clip-${locale})`">
        <rect width="60" height="42" fill="#012169" />
        <path d="M0 0 60 42M60 0 0 42" stroke="#fff" stroke-width="9" />
        <path d="M0 0 60 42M60 0 0 42" stroke="#C8102E" stroke-width="4" />
        <rect x="24" width="12" height="42" fill="#fff" />
        <rect y="15" width="60" height="12" fill="#fff" />
        <rect x="26.5" width="7" height="42" fill="#C8102E" />
        <rect y="17.5" width="60" height="7" fill="#C8102E" />
      </g>
    </template>
  </svg>
</template>

<style scoped>
.locale-flag {
  display: inline-block;
  width: 22px;
  height: 16px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px oklch(0 0 0 / 0.16);
  flex: none;
}
</style>
